import { createTheme } from '@mui/material/styles';
import { blue, grey, green, red, gold } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    h1: {
      fontSize: '38px',
      fontWeight: 'bold',
      lineHeight: '46px',
    },
    h2: {
      fontSize: '30px',
      fontWeight: 'bold',
      lineHeight: '38px',
    },
    h3: {
      fontSize: '24px',
      fontWeight: 'bold',
      lineHeight: '32px',
    },
    h4: {
      fontSize: '20px',
      fontWeight: 'bold',
      lineHeight: '28px',
    },
    h5: {
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '24px',
    },
    h6: {
      fontSize: '14px',
      fontWeight: 'regular',
      lineHeight: '22px',
    },
    body1: {
      fontSize: '14px',
      fontWeight: 'regular',
      lineHeight: '22px',
    },
    body2: {
      fontSize: '12px',
      fontWeight: 'regular',
      lineHeight: '20px',
    },
    subtitle1: {
      fontSize: '14px',
      fontWeight: 'medium',
      lineHeight: '22px',
    },
    subtitle2: {
      fontSize: '12px',
      fontWeight: 'medium',
      lineHeight: '20px',
    },
    caption: {
      fontSize: '12px',
      fontWeight: 'regular',
      lineHeight: '20px',
    },
  },
  customShadows : {
    button: `0 2px #0000000b`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0px 2px 8px ${alpha('#262626', 0.15)}`
  },
  palette: {
    primary: {
      lighter: '#e6f7ff',
      100: '#bae7ff',
      200: '#91d5ff',
      light: '#69c0ff',
      400: '#40a9ff',
      500: '#1890ff',
      main: '#1890ff',
      dark: '#096dd9',
      700: '#0050b3',
      darker: '#003a8c',
      900: '#002766',
    },
    secondary: {
      lighter: '#fafafa',
      100: '#f5f5f5',
      200: '#f0f0f0',
      light: '#d9d9d9',
      400: '#bfbfbf',
      500: '#8c8c8c',
      main: '#595959',
      600: '#595959',
      dark: '#262626',
      800: '#141414',
      darker: '#000000',
      A100: '#ffffff',
      A200: '#434343',
      A300: '#1f1f1f',
    },
    success: {
      lighter: '#f6ffed',
      light: '#95de64',
      main: '#52c41a',
      dark: '#237804',
      darker: '#092b00',
    },
    error: {
      lighter: '#fff1f0',
      light: '#ff7875',
      main: '#f5222d',
      dark: '#a8071a',
      darker: '#5c0011',
    },
    warning: {
      lighter: '#fffbe6',
      light: '#ffd666',
      main: '#faad14',
      dark: '#ad6800',
      darker: '#613400',
    },
  },
  customShadows: {
    button: `0 2px #0000000b`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0px 2px 8px ${alpha("#000000", 0.15)}`
  },
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 20,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginLeft: 1,
        },
        inset: {
          marginLeft: -1,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter, Arial, sans-serif',
        },
      },
    },
  },
  dashboard: {
    margins: "10px 30px 10px 30px",
  },
});

export default theme;
